import React from "react";

const MainconternLayout = ({ header, children, footer, loader }) => {
  return (
    <div className="medicine-layout">
      <div className="medicine-layout__header">{header}</div>
      <div className="medicine-layout__body">{children}</div>
      <div className="medicine-layout__footer d-flex justify-content-end">
        {footer}
      </div>
    </div>
  );
};

export default MainconternLayout;
